<template>
  <div class="w-100">
    <template v-if="data.variant.length == 0">
      <div class="p-3 radius-6 mb-3 border-semi-grey">
        <div class="row no-gutters">
          <div class="col-12" v-if="data.variant.length == 0">
            <div class="row slim-grid-row">
              <div class="align-self-center col-8">
                <p class="mb-1 body-2-4">{{data.product.data.name}}</p>
                <p class="mb-0 body-2-1">{{ formatCurrency(final_price())}}</p>
              </div>
              <div class="col-4 align-self-center">
                <div class="plus-min-set text-right">
                  <i class="simple-icon-minus d-inline-block align-middle text-green text-32 cursor-pointer" @click="changeQtyProduct('minus',data.qty)"></i>
                  <p class="d-inline-block align-middle border-none text-center body-1-4 counter mb-0" style="width:40px;">{{data.qty}}</p>
                  <i class="simple-icon-plus d-inline-block align-middle text-green text-32 cursor-pointer" @click="changeQtyProduct('plus',data.qty)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="p-3 radius-6 mb-3 border-semi-grey" v-for="(variant,index) in data.variant">
        <div class="row slim-grid-row">
          <div class="align-self-center col-8">
            <p class="mb-1 body-2-4">{{data.product.data.name}}</p>
            <p class="mb-1 body-2-1 text-orange">{{ variant.data.name }}</p>
            <p class="mb-0 body-2-1">{{ formatCurrency(final_price(false,variant.data.price))}}</p>
          </div>
          <div class="col-4 align-self-center">
            <div class="plus-min-set text-right">
              <i class="simple-icon-minus d-inline-block align-middle text-green text-32 cursor-pointer" @click="changeQtyProduct('minus',variant.qty,variant.data)"></i>
              <p class="d-inline-block align-middle border-none text-center body-1-4 counter mb-0" style="width:40px;">{{variant.qty}}</p>
              <i class="simple-icon-plus d-inline-block align-middle text-green text-32 cursor-pointer" @click="changeQtyProduct('plus',variant.qty,variant.data)"></i>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Product Note -->
    <PopupInputNote 
      v-if="is_note" 
      :title="note_title"
      :data="note_vuex.notes"
      @cancel="toggleNote" 
      @submit="submitNote"></PopupInputNote>
  </div>
</template>
<script>
	import {formatCurrency} from '@/utils/index.js'
  import {mapGetters,mapMutations} from 'vuex';
  import PopupInputNote from '@/components/hotel/concierge/general/PopupInputNote'

  export default{
    components:{
      PopupInputNote
    },
  	props:{
      data:{
        type: Object,
        default: () => {}
      }
    },
    data(){
      return{
        is_note: false,
        note_title: '',
        note_vuex: {
          product_id: '',
          variant_id: '',
          notes: ''
        }
      }
    },
  	methods:{
      ...mapGetters(['getConciergeOrder']),
  		...mapMutations(['setConciergeOrderExperience','removeConciergeOrderExperience','setConciergeOrderExperienceNote']),
  		formatCurrency(value){
        return formatCurrency(value);
      },
      final_price(is_default=true,variant_price){
        let price =  0
        if(is_default){
          price = this.data.product.data.price
        }else{
          price = variant_price
        }

        let total = price.price_sell
        if(price.promotion_amount > 0 && price.promotion_type == 'INCREASE'){
          total += price.promotion_amount
        }
        return total
      },
      changeQtyProduct(type,qty,variant=false){
      	let params = {
          merchant: this.getConciergeOrder().experience.merchant,
          product: this.data.product.data,
          variant: variant == false ? {} : variant,
          qty: qty
        }
      	if(type == 'minus' && qty == 1){
      			this.removeConciergeOrderExperience(params)
      	}else{
      		if(type == 'minus'){
            params.qty--
          }else{
            params.qty++
          }
          this.setConciergeOrderExperience(params)
      	}
      },
      toggleNote(variant_index=null){
        this.is_note = !this.is_note
        if(this.is_note){
          this.note_title = this.data.product.is_variant ? `[${this.data.variant[variant_index].data.name}] ${this.data.product.data.name}` : this.data.product.data.name
          this.note_vuex = {
            product_id: this.data.product.data.id,
            variant_id: variant_index == null ? '' : this.data.variant[variant_index].data.id,
            notes: variant_index == null ? this.data.notes : this.data.variant[variant_index].notes
          }   
        }else{
          this.note_title = ''
          this.note_vuex = {
            product_id: '',
            variant_id: '',
            notes: ''
          }
        }
      },
      submitNote(notes){
        this.note_vuex.notes = notes
        this.setConciergeOrderExperienceNote(this.note_vuex)
        this.toggleNote()
      }
  	}
  }
</script>
<style>
  .input-custom-padding{
    padding: 8px 8px 8px 42px;
  }
  .icon-form-position{
    top: 11px;
    left: 12px;
  }
  .img-crement {
    padding: 7px;
    border-radius: 5px;
  }
  @media screen and (max-width: 600px) {
    .plus-min-set {
      margin-left: -20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/productCartExperience.vue